import { cn } from "utils/helpers";

interface ScoringProgressBarProps {
	percentComplete: number;
}

/**
 * Full-width scoring progress bar for the supplier scoring modal. Rendered in the
 * modal header (via the Modal `headerAccessory` slot) so it spans the entire
 * header beneath the title, auto-save message and header buttons.
 */
export const ScoringProgressBar = ({
	percentComplete,
}: ScoringProgressBarProps) => {
	return (
		<div className="w-full" data-testid="progress-bar-container">
			<div className="flex items-center justify-between mb-1">
				<span className="text-xs text-gray-500">Progress</span>
				<span className="text-xs font-medium text-gray-700">
					{percentComplete}%
				</span>
			</div>
			<div className="h-2 w-full overflow-hidden rounded-full bg-gray-200">
				<div
					className={cn(
						"h-full rounded-full transition-all duration-300",
						percentComplete === 100 ? "bg-green-500" : "bg-blue-500"
					)}
					style={{ width: `${percentComplete}%` }}
					data-testid="progress-bar"
				/>
			</div>
		</div>
	);
};
